export default __webpack_public_path__ + "static/media/nftSystemBgMb.3dfcb350.png";